import React from 'react';
import { ShieldAlert } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Explicitly log the error to the console for easier troubleshooting
    console.group('%c 🔴 REACT ERROR BOUNDARY CAUGHT AN ERROR', 'background: #fee2e2; color: #991b1b; font-weight: bold; padding: 4px; border-radius: 4px;');
    console.error("Error:", error);
    console.error("Error Info:", errorInfo);
    console.groupEnd();
    
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
          <div className="bg-white rounded-[2rem] p-8 max-w-md w-full shadow-sm border border-slate-100 flex flex-col items-center text-center">
            <div className="w-20 h-20 bg-rose-50 rounded-full flex items-center justify-center mb-6">
              <ShieldAlert className="w-10 h-10 text-rose-500" />
            </div>
            <h1 className="text-2xl font-black text-slate-900 mb-3">Oops! Something went wrong.</h1>
            <p className="text-slate-500 font-medium mb-8">
              We encountered an unexpected error while loading this page. 
              Please refresh or go back to the home page.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="w-full py-4 rounded-2xl bg-indigo-600 text-white font-black hover:bg-indigo-700 transition-colors shadow-lg shadow-indigo-200"
            >
              Back to Home
            </button>
            {process.env.NODE_ENV !== 'production' && this.state.errorInfo && (
              <details className="mt-8 text-left w-full bg-slate-50 p-4 rounded-xl overflow-auto text-xs text-slate-600">
                 <summary className="font-bold cursor-pointer text-indigo-500 mb-2">Technical Details</summary>
                 <pre>{this.state.errorInfo.componentStack}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
